/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  list: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  offset: {
    type: Array
  },
  placement: {
    type: String,
    "default": "right-bottom",
    validator: function validator(val) {
      if (!val) return true;
      return ["right-top", "right-center", "right-bottom", "left-top", "left-center", "left-bottom"].includes(val);
    }
  },
  popupProps: {
    type: Object
  },
  shape: {
    type: String,
    "default": "square",
    validator: function validator(val) {
      if (!val) return true;
      return ["square", "round"].includes(val);
    }
  },
  type: {
    type: String,
    "default": "normal",
    validator: function validator(val) {
      if (!val) return true;
      return ["normal", "compact"].includes(val);
    }
  },
  width: {
    type: [String, Number]
  },
  onClick: Function,
  onHover: Function
};

export { props as default };
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/sticky-tool/props.js
// module id = null
// module chunks = 